import Main from './subPages/main';
import CompanyCategoriesDocumentPages from './subPages/companyDocumentCategories';

const routes = [
  {
    path: '/company_documents/*',
    canUse: [],
    Component: Main,
  },
  {
    path: '/company_document_categories/*',
    canUse: [],
    Component: CompanyCategoriesDocumentPages,
  },
];

export default routes;
